import { RequestAction, createRequestActionCreators } from 'helpers/actionsHelpers'
import { Meeting, MeetingsDataStateCollection, MeetingUid } from 'components/features/coaching/advisorPage/types/interfaces'
import { AdvisorsCollectionDataState } from 'components/features/coaching/advisorStore/interfaces/state'
import { createRequestAction } from 'helpers/actionHelpers/createRequestAction'
import { Member } from 'interfaces/member'
import { Advisor } from 'components/features/coaching/advisor/types/advisor'


type MeetingsListRequestPayload = {}
type MeetingsListRequestResponse = {
  advisors: AdvisorsCollectionDataState
  meetings: MeetingsDataStateCollection
}
export const MEETINGS_LIST_REQUEST = 'MEETINGS_LIST_REQUEST' as const
type MeetingsListRequest = RequestAction<typeof MEETINGS_LIST_REQUEST, MeetingsListRequestPayload, MeetingsListRequestResponse>
export const meetingsListRequestActionCreator = createRequestActionCreators<typeof MEETINGS_LIST_REQUEST, MeetingsListRequestPayload, MeetingsListRequestResponse>(MEETINGS_LIST_REQUEST)

export class GetMeetingsInfoAction extends createRequestAction<'GET_MEETINGS_INFO', void, Pick<Member, 'is_meeting_eligible' | 'had_appointed_meeting'>>('GET_MEETINGS_INFO') {}

export class GetMeetingAction extends createRequestAction<'GET_MEETING', { uid: MeetingUid }, { meeting: Meeting, advisor: Advisor }>('GET_MEETING') {}

export type AdvisorPageActions =
  | MeetingsListRequest
  | typeof GetMeetingsInfoAction.Type
  | typeof GetMeetingAction.Type
